#@import obscura
#@import BookingComponents
#@export GliveBooking

# Prepare namespace
window.GliveBooking ?= {}

window.GliveBooking.rootUrl     ?= "/GliveBooking"
window.GliveBooking.Collections ?= {}
window.GliveBooking.Models      ?= {}
window.GliveBooking.Presenters  ?= {}
window.GliveBooking.Views       ?= {}
window.GliveBooking.FilteredCollections ?= {}
